export const getStyles = (c, { palette = {} }) => {
  const helpLink = {
    color: palette.themePrimary,
    border: 'none',
    background: 'none',
    padding: 0,
    textDecoration: 'underline',
    '&:active,&:hover': {
      color: palette.themeDarker,
    },
    '&:focus': {
      outline: `1px solid ${palette.neutralSecondary}`,
    },
    '&:disabled': {
      color: palette.neutralTertiary,
    },
  };
  return {
    helpLink,
  };
};
